import {SET_ACTIVE_INVERTER} from '../actionTypes';

export const aciveInverterDispatcher = (inverterId) => {
  return {
    type: SET_ACTIVE_INVERTER,
    payload: {inverterId},
  };
};
